import { Box, Center, type CenterProps, Spinner } from "@chakra-ui/react"
import { keyframes } from "@emotion/react"

const appear = keyframes`
  to {
    transform: unset;
  }
`

type Props = CenterProps & {
  noAppearDelay?: boolean
}

export const FullLoader: React.FC<Props> = ({ noAppearDelay, ...props }) => {
  return (
    <Center {...props} boxSize="full" minH={20} data-testid="full-loader">
      <Box
        animation={`${appear} 300ms ${noAppearDelay ? "0s" : "300ms"} ease-out forwards`}
        transform="scale(0)"
      >
        <Spinner size="xl" />
      </Box>
    </Center>
  )
}
